import type { SentimentLevel } from '@copilot/shared';
import { cn } from '../../lib/cn';
import { SENTIMENT_LABELS } from '../../lib/labels';

/** Negative meetings are squares, so the marks do not rely on color alone. */
const MARKS: Record<SentimentLevel, string> = {
  very_positive: 'rounded-full bg-good',
  positive: 'rounded-full bg-good',
  neutral: 'rounded-full bg-line-strong',
  negative: 'rounded-[2px] bg-danger',
  very_negative: 'rounded-[2px] bg-danger',
  unknown: 'rounded-full bg-line-strong',
};

/** A compact row of recent-meeting marks, newest first. */
export function SentimentMarks({ levels, max = 5 }: { levels: SentimentLevel[]; max?: number }) {
  const shown = levels.slice(0, max);
  return (
    <span
      className="inline-flex items-center gap-1"
      role="img"
      aria-label={`Recent meetings, newest first: ${shown.map((l) => SENTIMENT_LABELS[l]).join(', ')}`}
    >
      {shown.map((level, i) => (
        <span key={i} className={cn('block h-2 w-2', MARKS[level])} />
      ))}
    </span>
  );
}
